import { render, staticRenderFns } from "./UpsertAttributeModal.vue?vue&type=template&id=58696901&"
import script from "./UpsertAttributeModal.vue?vue&type=script&lang=js&"
export * from "./UpsertAttributeModal.vue?vue&type=script&lang=js&"
import style0 from "./UpsertAttributeModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports